import { isFuture } from 'date-fns';
import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class ProductGoal extends Model<Schemas['productGoals'], Models> {
    get periodEndDate() {
        return nullableDate(this.periodEnd);
    }

    /** Whether `current` and `streak` are for the period that's under way. */
    get isCurrent(): boolean {
        return !!this.periodEndDate && isFuture(this.periodEndDate);
    }

    get isComplete(): boolean {
        return !!this.questions && (this.current || 0) >= this.questions;
    }
}
